import firebase from "firebase/compat/app";
import "firebase/compat/firestore"


//初期化
const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDwAdbhUFfhvnu1cgxSiVIn-r7ElPSqBng",
  authDomain: "alcohole-d670e.firebaseapp.com",
  projectId: "alcohole-d670e",
  storageBucket: "alcohole-d670e.appspot.com",
  messagingSenderId: "588490266938",
  appId: "1:588490266938:web:65babc26cfe66557071803",
  measurementId: "G-S4XQ506ZFX"
});

//取得
const db = firebaseApp.firestore()

export default db
